import alt from '../alt';
import generateWithAsyncActions from 'epic-alt-utils/index';

export default generateWithAsyncActions(alt, [
    'getPatchNotes', 'clearErrorStatus'
]);
